export default "__VITE_ASSET__CMZnG2P$__"